import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { WithTranslation, withTranslation } from 'react-i18next';

import { withEnhancedStyleLoader } from '../../withEnhancedStyleLoader';
import Settings from '../settings';
import WidgetRoot from './Widget/widgetRoot';
import PopupRoot from '../popup';

interface AppProps extends WithTranslation {
  initialState: any;
}

const App = (props: AppProps) => {
  const IS_DEV = (process.env.NODE_ENV as string) === 'development';
  const domain = !IS_DEV ? '/wix-labs/google-calendar' : '';

  return (
    <Switch>
      <Route path={`${domain}/index`} render={() => <WidgetRoot />} />
      <Route path={`${domain}/settings`} render={() => <Settings />} />
      <Route path={`${domain}/popupApp`} render={() => <PopupRoot />} />
    </Switch>
  );
};

export default withTranslation()(withEnhancedStyleLoader(App));
